import {
  activityColumnDefinition,
  activityDescriptionColumnDefinition,
  allowEntryColumnDefinition,
  allowTopsideColumnDefinition,
  allowTransferColumnDefinition,
  slAccountColumnDefinition,
  slGlJournalExistsColumnDefinition,
  slViewColumnDefinition,
  typeColumnDefinition,
  typeDescriptionColumnDefinition,
} from '../columnDefinitions';

export default [
  typeColumnDefinition,
  typeDescriptionColumnDefinition,
  allowTopsideColumnDefinition,
  activityColumnDefinition,
  activityDescriptionColumnDefinition,
  slAccountColumnDefinition,
  slViewColumnDefinition,
  allowEntryColumnDefinition,
  allowTransferColumnDefinition,
];

export const exportTaxEntryColumnDefs = [
  typeColumnDefinition,
  typeDescriptionColumnDefinition,
  allowTopsideColumnDefinition,
  activityColumnDefinition,
  activityDescriptionColumnDefinition,
  slAccountColumnDefinition,
  slViewColumnDefinition,
  allowEntryColumnDefinition,
  allowTransferColumnDefinition,
  slGlJournalExistsColumnDefinition,
];
